import Color from 'color';
import getTextColorForBackground from './getTextColorForBackground';

function blendChannelWithAlpha(channel: number, alpha: number) {
  return alpha * channel + 255 * (1 - alpha);
}

export default function getColorForGradientBackground(hex: string) {
  const { r, g, b } = Color(hex).object();

  const realGradientStart = Color({
    r: blendChannelWithAlpha(r, 0.45),
    g: blendChannelWithAlpha(g, 0.45),
    b: blendChannelWithAlpha(b, 0.45),
  });

  return getTextColorForBackground(realGradientStart.hex());
}
